export const NBSP = '\u00A0'
